import { ChangeEvent, FunctionComponent, useCallback } from 'react';
import { FormControl, FormHelperText, Grid, TextField } from '@material-ui/core';

type FieldPaymentPercentProps = {
    error: boolean;
    setValue: (percent: number) => void;
    value: number;
    formHelperText: string;
};

const FieldPaymentPercent: FunctionComponent<FieldPaymentPercentProps> = ({ error, setValue, value, formHelperText }) => {
    const onChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value.trim();
        if (value.match(/^\d+$/)) {
            setValue(+value);
        }
    }, [setValue]);
    return <Grid item xs={3} sm={12}>
        <FormControl error={error} fullWidth size="small">
            <TextField type="number" name="payment_percent" value={value} onChange={onChange} size="small" />
            <FormHelperText> {formHelperText} </FormHelperText>
        </FormControl>
    </Grid>;
};

export default FieldPaymentPercent;